import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 14v-6h6","key":"svg-0"}],["path",{"d":"M3 8l9 9l9 -9","key":"svg-1"}]]

const IconArrowElbowLeft = createReactComponent('outline', 'arrow-elbow-left', 'ArrowElbowLeft', __iconNode);

export default IconArrowElbowLeft;